var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useUpdateCompanyStatusMutation } from '../../../../application/features/companies/company-api';
import useTranslate from '../../../../localization/helpers';
var ActivateCompanyDialog = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, company = _a.company;
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction, tWithField = _b.tWithField;
    var _c = __read(useUpdateCompanyStatusMutation(), 2), updateCompanyStatus = _c[0], _d = _c[1], updateCompanyStatusLoading = _d.isLoading, updateCompanyStatusSuccess = _d.isSuccess;
    var handleSubmit = useForm({ reValidateMode: 'onChange' }).handleSubmit;
    var successMessage = useCallback(function () {
        enqueueSnackbar(tWithField('toolTips.activateSuccess', 'common.company'), {
            autoHideDuration: 3000,
            variant: 'success',
            anchorOrigin: { horizontal: 'right', vertical: 'top' }
        });
        onClose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onClose]);
    useEffect(function () {
        if (updateCompanyStatusSuccess)
            successMessage();
    }, [successMessage, updateCompanyStatusSuccess]);
    var onSubmit = function (request) {
        updateCompanyStatus(__assign(__assign({}, request), { isActive: true, id: company.id }));
    };
    return (_jsxs(Dialog, { open: isOpen, children: [_jsx(DialogTitle, { id: 'confirm-dialog-title', children: tWithFunction('actions.activateFunction', 'common.company') }), _jsx(DialogContent, { children: _jsx(DialogContentText, { id: 'confirm-dialog-description', children: tWithFunction('companies.statusConfirmText', 'common.activate') }) }), _jsxs(DialogActions, { children: [_jsx(Button, { disabled: updateCompanyStatusLoading, variant: 'outlined', color: 'inherit', onClick: onClose, children: translate('actions.cancel') }), _jsx(Button, { disabled: updateCompanyStatusLoading, onClick: handleSubmit(onSubmit), variant: 'contained', color: 'warning', children: translate('actions.confirm') })] })] }));
};
export default ActivateCompanyDialog;
